<div class="site-header header-style-1 nav-wide" [class.header-is-sticky]="isSticky">
  <!-- @if (!production) {
  <div class="env-banner" role="status">
    <span class="env-banner-dot" aria-hidden="true"></span>
    THIS IS A {{name}} ENVIRONMENT
  </div>
  } -->
  <div class="sticky-header main-bar-wrapper navbar-expand-lg" [class.is-stuck]="isSticky">
    <div class="main-bar">
      <div class="container clearfix">
        <div class="logo-header">
          <div class="logo-header-inner logo-header-one">
            <a routerLink="/" class="vp-brand" aria-label="Vishwas Fotography home">
              <span class="vp-brand-name">VISHWAS FOTOGRAPHY</span>
            </a>
          </div>
        </div>
        <button type="button" class="navbar-toggler" data-toggle="collapse" data-target=".navbar-collapse"
          data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false"
          aria-label="Toggle navigation" (click)="resetHamburguerIcon()">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar icon-bar-first"></span>
          <span class="icon-bar icon-bar-two"></span>
          <span class="icon-bar icon-bar-three"></span>
        </button>

        <div [class.show]="!isCollapsed" id="navbarSupportedContent"
          class="header-nav nav-light navbar-collapse collapse justify-content-end">
          <ul class="nav navbar-nav">
            <li><a routerLink="/" href="/" routerLinkActive="active" (click)="collapseNavbar()">Home</a>
            </li>
            <li><a routerLink="/photography" href="/photography" routerLinkActive="active"
                (click)="collapseNavbar()">Photography</a>
            </li>
            <li><a routerLink="/contact" routerLinkActive="active" href="/contact"
                (click)="collapseNavbar()">Contact</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>